import api from '../utils/api';

const taskService = {
  getTasks:   (params) => api.get('/tasks', { params }),
  createTask: (data)   => api.post('/tasks', data),
  updateTask: (id, data) => api.put(`/tasks/${id}`, data),
  deleteTask: (id)     => api.delete(`/tasks/${id}`),
};

export default taskService;
